import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { deleteWhiteListPage, resetStore } from '../actions/GenericActions';
import AppRouter from '../router/AppRouter';

const mapDispatchToProps = dispatch => ({
  deleteWhiteListPage: step => dispatch(deleteWhiteListPage(step)),
  resetStore: () => dispatch(resetStore()),
});

export default withRouter(connect(null, mapDispatchToProps)(AppRouter));
